import { gql } from '@apollo/client';

export const GET_TEACHERLISTS = gql`
  query SkWeb_TeacherList(
    $page: Int
    $pageSize: Int
    $tempPrincipalId: ID
    $schoolId: ID
  ) {
    teacherList(
      page: $page
      pageSize: $pageSize
      tempPrincipalId: $tempPrincipalId
      schoolId: $schoolId
    ) {
      data {
        id
        name
        username
        products {
          id
          name
        }
        classroom {
          id
          name
          highScore
          mediumScore
          lowScore
          school {
            id
            name
          }
          studentsLength
        }
      }
      totalCount
    }
  }
`;
